import { createContext, useContext, useEffect, useRef, useState } from "react"
import { useAuth } from "../../auth/auth-provider/auth-provider";
import { GetGoldPriceType } from "../../api-layer/gold-price-type-api/GetGoldPriceType";

const GoldPriceTypeContext = createContext();

const GoldPriceTypeProvider = ({children}) => {
    const [sellType, setSellType] = useState(null);
    const [buyType, setBuyType] = useState(null);
    const [goldPriceTypes, setGoldPriceTypes] = useState(null);
    const [adminGoldPriceTypes, setAdminGoldPriceTypes] = useState(null);
    const auth = useAuth()

     useEffect(() => {
       getGoldPriceTypes();
       getAdminGoldPriceTypes();
    }, [auth?.token, sellType?.value, buyType?.value])

    const getGoldPriceTypes = () => {
        GetGoldPriceType().then(
            res => {
                setPriceTypes(res.data);
            }
        ).catch(
            error => {

            }
        );
    }

    const getAdminGoldPriceTypes = () => {
        GetGoldPriceType('admin').then(
            res => {
                setAdminGoldPriceTypes(res.data);
            }
        ).catch(
            error => {
            }
        );
    }

    const setPriceTypes = (priceTypes) => {
        setGoldPriceTypes(priceTypes);
        for(let type of priceTypes){
            if(type.name === 'online sell'){
                setSellType(type);
            } else if(type.name === 'online buy'){
                setBuyType(type);
            } else {

            }
        }
    }

    return (
        <>
            <GoldPriceTypeContext.Provider
                value={{sellType, setSellType, buyType, setBuyType, goldPriceTypes, adminGoldPriceTypes}}
            >
                {children}
            </GoldPriceTypeContext.Provider>
        </>

    ) ;
};

export default GoldPriceTypeProvider;

export const useGoldPriceTypes = () => {
    return useContext(GoldPriceTypeContext);
};
